import amber from './images/icons/amber.png';
import barley from './images/icons/barley.png';
import bibi from './images/icons/bibi.png';
import crow from './images/icons/crow.png';
import emz from './images/icons/emz.png';
import frank from './images/icons/frank.png';
import leon from './images/icons/leon.png';
import lou from './images/icons/lou.png';
import mrp from './images/icons/mrp.png';
import primo from './images/icons/primo.png';
import sandy from './images/icons/sandy.png';
import sneaky from './images/icons/sneaky.png';
import spike from './images/icons/spike.png';
import sprout from './images/icons/sprout.png';
import stu from './images/icons/stu.png';

export const challenges = [
  {
    icon: stu,
    title: 'Look Like Stu',
    info: "Play standing on one foot with one eye closed. Win the game and don't fall down.",
  },
  {
    icon: emz,
    title: "Emz's Selfie Challenge",
    info: 'Win, playing the entire time with toilet paper wrapped around your head, holding your phone vertically.',
  },
  {
    icon: mrp,
    title: "Mr. P's Plunge",
    info: 'Submerge your hands in a bowl of ice water for 20 seconds, then play and win.',
  },
  {
    icon: primo,
    title: "El Primo's Workout Video",
    info: 'Do 5 squats for every gem. If you wear a luchador mask, you only have to do 4.',
  },
  {
    icon: crow,
    title: "Crow's Beak Challenge",
    info: 'Win the game, playing using only your nose.',
  },
  {
    icon: sandy,
    title: "Sandy's Breakfast Challenge",
    info: 'Win, eating a spoonful of crushed graham crackers/cereal for every kill (minimum 5 spoonfuls).',
  },
  {
    icon: amber,
    title: 'Amber Brings the Heat',
    info: 'Win the game, taking a bite of a spicy food every time you get a gem.',
  },
  {
    icon: frank,
    title: "Frank's Sponge Challenge",
    info: (
      <>
        Win playing as Frank. Every time you get kille
        <span style={{ letterSpacing: '-3px' }}>d</span>, wring a sponge out over your head.
      </>
    ),
  },
  {
    icon: barley,
    title: "Barley's Cocktail",
    info: 'Mix a drink with three random ingredients and drink it before your game ends.',
  },
  {
    icon: leon,
    title: "Leon's Hoodie",
    info: 'Play wearing a hoodie and remove it after your second kill without stopping the game.',
  },
  {
    icon: sneaky,
    title: 'Sneaky Super Challenge',
    info: 'Win a match using only your Super.',
  },
  {
    icon: bibi,
    title: "Bibi's Bubble Gum Challenge",
    info: 'Win a game of brawl ball, putting 4 pieces of gum in your mouth every goal (minimum 8 pieces).',
  },
  {
    icon: spike,
    title: 'Spike Ball Challenge',
    info: 'After every kill, toss a ball into a garbage can 10 feet away. Win & make minimum 2 shots.',
  },
  {
    icon: sprout,
    title: 'Sprout Vision',
    info: 'Draw a face on a Post-it and play with it over your eyes. Swap Post-its every kill.',
  },
  {
    icon: lou,
    title: "Lou's Brain Freeze Challenge",
    info: 'Win the game, taking a bite of ice cream for every opponent you freeze (minimum two).',
  },
];
